var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"video-embed-box"},[_c('div',{staticClass:"background-mask"},[_c('img',{staticClass:"backgroundImg",attrs:{"src":_vm.item?.cover_thumbnail_urls[0]?.url,"alt":""}})]),_vm._v(" "),_c('a-video-player',{ref:"videoComp",staticClass:"container",attrs:{"id":`video-${_vm.index}`,"ref-key":`${_vm.index}`,"src":_vm.item?.cloud_manifest_info || _vm.formatUrls(_vm.item?.main_mv_urls[0]?.url),"webkit-playsinline":"true","preload":"auto","poster":_vm.formatUrls(_vm.item?.cover_first_frame_urls?.[0]?.url),"plays-inline":"","index":_vm.index,"loop":true,"photo-id":_vm.item?.photo_id_str,"autoplay":true,"stat-logger-params":{
            list_id: _vm.item?.list_id,
            user_id: _vm.item?.user_id,
            exp_tag: _vm.item?.exp_tag,
            show_index: 5001 + _vm.index,
        },"plugins":{
            ContorlPlugin: {
                muted: _vm.muted,
                duration: 0,
                playTime: 0,
                paused: false,
            },
        },"controls":false,"muted":_vm.muted,"biz-data":{ pageSource: 'pc-video-embed', page_code: 'pc-video-embed' }},on:{"click":_vm.onClickVideo,"waiting":_vm.onWaiting,"playing":_vm.onPlaying,"error":_vm.onError,"ended":_vm.onEnded,"pause":_vm.onPause}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }